<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm ref="formref" method="put" :fields="formfields" :data-form="rowdata" :before="formbefore" label-width="100px" :is-show-btn="false" form-style="width:calc(33% - 10px);display:inline-block" label-position="left" />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电单价</span>
      </div>
      <STable v-if="showTable" ref="tableref" :selection="false" :columns="columns" :list-data="listData" />
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">服务费分润设置</span>
      </div>
      <el-form :model="profitForm" label-width="120px">
        <el-form-item label="分润模式">
          {{ profitForm.mode=='PERCENT'?'按比例分润':'按固定金额分润' }}
        </el-form-item>
        <el-form-item v-if="profitForm.mode=='PERCENT'" label="分润方设置">
          <div style="display:flex;align-items: center;flex-wrap: wrap;">
            <span v-for="(item,index) in profitForm.shareBl" :key="index" style="width:calc(25% - 20px);margin-right: 20px;">
              {{ queryShare(item.type) }}&nbsp;&nbsp;&nbsp;{{ item.value }}%
            </span>
          </div>
        </el-form-item>
        <el-form-item v-else label="分润方设置">
          <div style="display:flex;align-items: center;flex-wrap: wrap;">
            <span v-for="(item,index) in profitForm.shareJe" :key="index" style="width:calc(25% - 20px);margin-right: 20px;">
              {{ queryShare(item.type) }}&nbsp;&nbsp;&nbsp;{{ item.value }}元/度
            </span>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- <el-card shadow="never">
      <div slot="header">
        <span class="title">占位收费设置</span>
      </div>
      <el-form :model="rowdata" label-width="120px">
        <el-form-item label="是否收取占用费">
          {{ rowdata.occupy?'是':'否' }}
        </el-form-item>
        <div v-if="rowdata.occupy" style="display:flex;align-items: center;">
          <el-form-item label="停车缓冲时长" style="width: 300px;">
            {{ rowdata.bufferTime }}&nbsp;&nbsp;&nbsp;分钟
          </el-form-item>
          <el-form-item label="超时计费" style="width: 300px;">
            {{ rowdata.overMoney }}&nbsp;&nbsp;元&nbsp;/&nbsp;&nbsp;{{ rowdata.overTime }}&nbsp;&nbsp;分钟
          </el-form-item>
        </div>
      </el-form>
    </el-card> -->
    <el-card shadow="never">
      <div slot="header">
        <span class="title">终端列表</span>
      </div>
      <STable ref="tablerefs" :selection="false" :url="urls" :columns="columnss" />
    </el-card>
  </div>
</template>

<script>
import times from './data.json'
export default {
  name: 'Dianzhanxiangqing',
  components: {},
  data() {
    return {
      showTable: false,
      shareArray: [],
      editForm: {
        calculateMode: [],
        onTime: [],
        byVolume: []
      },
      profitForm: {
        mode: 'PERCENT',
        shareBl: [
          {
            value: '',
            type: 'operator'
          }
        ],
        shareJe: [
          {
            value: '',
            type: ''
          }
        ]
      },
      columns: [{
        label: '时段',
        prop: 'loginName'
      },
      {
        label: '电费（元/度）',
        prop: 'userName'
      },
      {
        label: '服务费（元/度）',
        prop: 'roleNames'
      }
      ],
      columns1: [{
        label: '时段',
        prop: 'loginName'
      },
      {
        label: '单价（元/度）',
        prop: 'userName'
      }],
      columnss: [{
        label: '终端名称',
        prop: 'connectorName'
      },
      {
        label: '电桩品牌',
        prop: 'brandName'
      },
      {
        label: '电桩型号',
        prop: 'brandModel'
      },
      // {
      //   label: "输出类型",
      //   prop: "outputType",
      // },
      {
        label: '电桩功率（KW）',
        prop: 'power'
      },
      {
        label: '工作状态',
        prop: 'workStatus'
      },
      {
        label: '启停状态',
        prop: 'frozen',
        template: function(index, reocrd) {
          return reocrd.disable
            ? "<span class='tag danger'>停用</span>"
            : "<span class='tag success'>启用</span>"
        }
      }
      ],
      listData: [],
      rowdata: {},
      formfields: [{
        label: '电站ID',
        type: 'div',
        style: 'width:100%',
        prop: 'id'
      },
      {
        label: '电站编号',
        type: 'div',
        style: 'width:100%',
        prop: 'stationId'
      },
      {
        label: '可用电容(增容)',
        type: 'div',
        style: 'width:100%',
        prop: 'capacitanceSize',
        unit: 'KV·A'
      },
      {
        label: '电桩总功率',
        type: 'div',
        style: 'width:100%',
        prop: 'equipmentPower',
        unit: 'KW'
      },
      {
        label: '电站地址',
        type: 'div',
        style: 'width:100%',
        prop: 'address'
      },
      {
        label: '场地坐标',
        type: 'div',
        style: 'width:100%',
        prop: 'lnglat'
      },
      {
        label: '运营商',
        type: 'div',
        style: 'width:100%',
        prop: 'operatorName'
      },
      {
        label: '电站位置',
        type: 'div',
        style: 'width:100%',
        prop: 'stationLocation'
      },
      {
        label: '场站道闸',
        type: 'div',
        style: 'width:100%',
        prop: 'brake'
      },
      {
        label: '停车说明',
        type: 'div',
        style: 'width:100%',
        prop: 'parkInstruction'
      },
      {
        label: '开放时间说明',
        type: 'div',
        style: 'width:100%',
        prop: 'busineHoursInstruction'
      },
      {
        label: '创建人',
        type: 'div',
        style: 'width:100%',
        prop: 'createUser'
      },
      {
        label: '创建时间',
        type: 'div',
        style: 'width:100%',
        prop: 'createTime'
      },
      {
        label: '场地属性',
        type: 'div',
        style: 'width:100%',
        prop: 'siteProperties'
      },
      {
        label: '电站类型',
        type: 'div',
        style: 'width:100%',
        prop: 'stationTypeValue'
      },
      {
        label: '建设场所',
        type: 'div',
        style: 'width:100%',
        prop: 'constructionValue'
      },
      {
        label: '站点服务设施',
        type: 'div',
        style: 'width:100%',
        prop: 'siteServiceValue'
      },
      {
        label: '周边基础设施',
        type: 'div',
        style: 'width:100%',
        prop: 'aroundServiceValue'
      },
      {
        label: '移动端可见性',
        type: 'div',
        style: 'width:100%',
        prop: 'appCanSee'
      },
      {
        label: '备注说明',
        type: 'div',
        style: 'width:100%',
        prop: 'remark'
      },
      {
        label: '运营状态',
        type: 'div',
        style: 'width:100%',
        prop: 'operatorStatusValue'
      },
      {
        label: '启停状态',
        type: 'div',
        style: 'width:100%',
        prop: 'disable'
      },
      {
        label: '所属资质',
        type: 'div',
        style: 'width:100%',
        prop: 'qualificationPicture'
      },
      {
        label: '站点描述',
        type: 'div',
        style: 'width:100%',
        prop: 'description'
      }
      ],
      formbefore: (record) => {
        console.log(record)
        return record
      },
      id: ''
    }
  },
  computed: {
    urls() {
      const stationId = this.id
      if (stationId) {
        return '/station/equipment/page?stationId=' + this.id
      }
      return ''
    }
  },
  mounted() {
    this.getAlloperator()
    if (this.id) {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/station/getEditData',
        data: data,
        method: 'get',
        callback: (resp) => {
          const lnglat = 'E' + String(resp.stationLng) + '，' + 'N' + String(resp.stationLat)
          this.rowdata = resp
          this.rowdata.lnglat = lnglat
          if (resp.brake === true) {
            this.rowdata.brake = '有道闸'
          } else if (resp.brake === false) {
            this.rowdata.brake = '无道闸'
          }

          if (resp.appCanSee === true) {
            this.rowdata.appCanSee = '可见'
          } else if (resp.appCanSee === false) {
            this.rowdata.appCanSee = '不可见'
          }
          if (resp.equipmentPower) {
            this.rowdata.equipmentPower = parseInt(resp.equipmentPower)
          }

          if (resp.disable === true) {
            this.rowdata.disable = '停用'
          } else if (resp.disable === false) {
            this.rowdata.disable = '启用'
          }
          this.listData = []
          const that = this
          if (resp.ranges.length > 0) {
            resp.ranges.forEach((item, index) => {
              const obj = {
                loginName: '',
                userName: '',
                roleNames: ''
              }
              let start = ''
              let end = ''
              if (times.timeList.length > 0) {
                times.timeList.forEach((el, em) => {
                  if (item.priceStartPeriod === el.value) {
                    start = el.label
                  }
                  if (item.priceEndPeriod === el.value) {
                    end = el.label
                  }
                })
              }
              if (start === '' && end === '') {
                obj.loginName = '其他时段'
              } else {
                obj.loginName = start + '至' + end
              }
              obj.userName = this.getFloat(item.cpoElecMoney)
              obj.roleNames = this.getFloat(item.cpoServiceMoney)
              that.listData.push(obj)
            })
            this.showTable = true
          }
          this.profitForm.mode = resp.profitMode
          if (resp.profitConfigs && resp.profitConfigs.length > 0) {
            if (resp.profitMode === 'PERCENT') {
              this.profitForm.shareBl = [{
                value: '',
                type: 'operator'
              }]
              resp.profitConfigs.forEach(item => {
                this.profitForm.shareBl.push({
                  value: item.share,
                  type: item.targetId
                })
              })
              this.$nextTick(() => {
                this.getOperator()
              })
            } else {
              this.profitForm.shareJe = []
              resp.profitConfigs.forEach(item => {
                this.profitForm.shareJe.push({
                  value: item.share,
                  type: item.targetId
                })
              })
            }
          }
        }
      })
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    getAlloperator() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/user/page',
        data: data,
        method: 'get',
        callback: (resp) => {
          if (resp.list && resp.list.length > 0) {
            this.shareArray = resp.list
          }
        }
      })
    },
    // 计算运营商分润比例
    getOperator() {
      if (this.profitForm.shareBl.length > 1) {
        let num = 100
        this.profitForm.shareBl.forEach((item, i) => {
          if (i > 0) {
            num = num - Number(item.value)
          }
        })
        const reg = /^\d+(?=\.{0,1}\d+$|$)/
        if (reg.test(num)) {
          this.profitForm.shareBl[0].value = num
        } else {
          this.$notify.error({
            title: '错误',
            message: '所有分润方比例相加超出100%'
          })
        }
      }
    },
    // 查询分润方名称
    queryShare(id) {
      let label = ''
      if (id === 'operator') {
        label = '运营商'
      } else {
        let val = this.shareArray.find((item) => {
          return item.id === id
        })
        val = val || ''
        label = val.loginName || ''
      }
      return label
    },
    cancel() {
      this.$router.go(-1)
    },
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/deep/ .el-form-item {
      .el-form-item__content {
        width: calc(100% - 120px);
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .form-card{
      padding:10px 20px;
      border:1px solid #e0e0e0;
      margin-top:20px;
      .title{
        margin:0 0 10px 0;
      }
    }
    /deep/ .el-card__header .title-btn {
      float: right;
      margin-left: 10px;
    }
    /deep/ .el-form-item__content .el-table {
      overflow: visible;
    }
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/plantDetail.vue